'use client';

import useSyncSettings from '@/app/(app)/games/[gid]/_src/useSyncSettings';

export default function Error(props) {
  const synced = useSyncSettings();

  if (synced) {
    throw props.error;
  }

  return null;
}
